var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChargesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 95.76,
    height: 96,
    viewBox: "0 0 95.76 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_330",
    x: 0,
    y: 32.327,
    width: 95.76,
    height: 63.673,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#2e8eb8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_331",
    x: 28.644,
    y: 0,
    width: 51.471,
    height: 51.513,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#2e8eb8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_332",
    x: 33.238,
    y: 50.311,
    width: 21.03,
    height: 21.03,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#2e8eb8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_333",
    x: 36.464,
    y: 9.033,
    width: 33.791,
    height: 33.447,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#2e8eb8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_259",
    "data-name": "Groupe 259",
    transform: "translate(2301.344 987.291)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_258",
    "data-name": "Groupe 258",
    transform: "translate(-2292.344 -981.291)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Trac\\xE9_330)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_330-2",
    "data-name": "Trac\\xE9 330",
    d: "M-2214.584-814.161c-1.229,2.576-3.327,4.494-5.091,6.659-2.959,3.633-6.024,7.179-9,10.8a13.224,13.224,0,0,1-10.617,4.992c-6.561.045-13.123.068-19.683-.019-2.26-.03-3.654,1.237-5.027,2.685a.734.734,0,0,0-.066.552,4.737,4.737,0,0,1-1.437,4.561c-2.305,2.244-4.583,4.517-6.877,6.772a1.607,1.607,0,0,1-2.676-.006q-8.3-8.358-16.594-16.723a1.6,1.6,0,0,1-.018-2.622q3.426-3.452,6.865-6.893a4.8,4.8,0,0,1,3.761-1.493.915.915,0,0,0,.7-.372c5.05-8.855,16.083-11.033,24.018-7.982a3.591,3.591,0,0,0,1.255.213c5.193.014,10.387.033,15.579,0a6.742,6.742,0,0,1,5.609,2.5,2.764,2.764,0,0,1,.349-.751c2.814-2.917,5.647-5.816,8.468-8.727a6.071,6.071,0,0,1,10.354,2.029.945.945,0,0,0,.13.179Zm-51.374,22.7a5.772,5.772,0,0,0,.47-.425,8.839,8.839,0,0,1,7.125-2.889c6.28.1,12.563.031,18.845.03a9.81,9.81,0,0,0,7.794-3.137c4.606-5.323,9.072-10.768,13.573-16.181a3.012,3.012,0,0,0-.306-4.239,3.035,3.035,0,0,0-4.246.214q-4.857,4.975-9.687,9.976a1.15,1.15,0,0,0-.322.706c-.031,4.022-2.538,6.555-6.547,6.565q-5.737.015-11.474,0a3.659,3.659,0,0,1-.976-.108,1.473,1.473,0,0,1-1.031-1.51,1.461,1.461,0,0,1,1.2-1.376,5.879,5.879,0,0,1,.984-.055q5.622-.005,11.246-.006a6.265,6.265,0,0,0,1.134-.081,3.009,3.009,0,0,0,2.366-3.449c-.3-1.642-1.505-2.562-3.419-2.564-5.421-.007-10.841.005-16.261-.015a4.687,4.687,0,0,1-1.622-.284,17.564,17.564,0,0,0-13.952.422,14.229,14.229,0,0,0-6.808,6.467Zm-7.4,11.362c1.831-1.929,3.741-3.955,5.669-5.965.935-.975.958-1.72,0-2.679q-6.2-6.211-12.417-12.414c-.953-.952-1.7-.942-2.665.027q-2.742,2.741-5.474,5.49c-.135.136-.255.287-.455.514Z",
    transform: "translate(2301.34 860.45)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Trac\\xE9_331)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_331-2",
    "data-name": "Trac\\xE9 331",
    d: "M-2133.054-981.291c.938.193,1.89.337,2.814.587a16.731,16.731,0,0,1,12.381,17.255,16.812,16.812,0,0,1-13.84,15.416,16.769,16.769,0,0,1-19.473-14.359,16.725,16.725,0,0,1,14.568-18.767,3.951,3.951,0,0,0,.51-.132Zm-1.564,30.441a13.682,13.682,0,0,0,13.737-13.611,13.7,13.7,0,0,0-13.575-13.783,13.7,13.7,0,0,0-13.812,13.622A13.679,13.679,0,0,0-2134.617-950.85Z",
    transform: "translate(2188.95 987.29)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Trac\\xE9_332)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_332-2",
    "data-name": "Trac\\xE9 332",
    d: "M-2125.66-732.027a1.514,1.514,0,0,1-1.505,1.485,1.562,1.562,0,0,1-1.523-1.562,1.527,1.527,0,0,1,1.6-1.467A1.484,1.484,0,0,1-2125.66-732.027Z",
    transform: "translate(2170.93 789.88)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -2301.34, -987.29)",
    filter: "url(#Trac\\xE9_333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_333-2",
    "data-name": "Trac\\xE9 333",
    d: "M-2097.013-933.822l-1.906,1.824c-1.889-1.855-4.034-2.656-6.591-1.678a4.713,4.713,0,0,0-2.442,2.43h6.75c-.372,1.216-.559,1.367-1.638,1.368-1.8,0-3.607,0-5.4,0-.334.921-.259,1.031.661,1.031h6.381c-.438,1.278-.547,1.359-1.735,1.359l-4.45,0h-.7c.231,1.7,1.97,3.138,4.121,3.4a5.778,5.778,0,0,0,5.011-2.1l1.876,1.975a8.252,8.252,0,0,1-6.763,2.827A7.37,7.37,0,0,1-2111-927.07a.738.738,0,0,0-.514-.4,9.094,9.094,0,0,0-1.287-.018c.31-1.086.533-1.287,1.568-1.421l.055-.95h-1.622c.291-1.079.543-1.279,1.482-1.411a.768.768,0,0,0,.505-.444c1.634-5.059,8.933-7.2,13.533-2.466A3.95,3.95,0,0,1-2097.013-933.822Z",
    transform: "translate(2158.27 951.85)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargesIcon);
export default __webpack_public_path__ + "static/media/charges-icon.6aff4bd4beb3fe1331e956c4fc5885db.svg";
export { ForwardRef as ReactComponent };